<script setup>

import { ref, onMounted, provide, nextTick } from 'vue';
import { useToast } from 'primevue/usetoast';

import Toast from 'primevue/toast';
import Bandeau from './components/bandeau/Bandeau.vue';
import MessageChargement from './components/bandeau/MessageChargement.vue';
import BarreFlottante from '@/components/generiques/BarreFlottante.vue';

import { 
	apiGetUtilisateur,
  apiModifierUtilisateur } from '@/services/ServiceModele.js';

const toast = useToast();

const utilisateur = ref(null);
const libellePage = ref("Accueil");
const messageChargement = ref(null);
const menuBarreFlottante = ref(null);

onMounted(() => {
  console.log('Recherche de l\'utilisateur...');
	apiGetUtilisateur().then(
		reponse => {
      console.log(reponse);
      utilisateur.value = reponse;
		}, 
		err => {
			gererErreurApi(err);
    });
});

function afficherBarreFlottante(contenuBarreFlottante) {
	menuBarreFlottante.value = contenuBarreFlottante;
}

function appelerApiTelechargement(fonctionApi, argumentsApi, fonctionApresReponse) {
  	const fonctionReponse = function(reponseOK, lienTelechargement) {
		if (reponseOK) {
      		telechargerFichier(lienTelechargement);
      		if (fonctionApresReponse != null) {
        		nextTick(() => fonctionApresReponse(true));
      		}
    	} else {
      		if (fonctionApresReponse != null) {
        		fonctionApresReponse(false);
      		}
    	}
  	};
		
	const messageChargement = 'Téléchargement en cours...';
	setMessageChargement(messageChargement);
	fonctionApi.apply(null, argumentsApi).then(
		reponse => {
			fonctionReponse(true, reponse);
			setMessageChargement(null);
      afficherSucces('Téléchargement terminé');
		}, err => {
			gererErreurApi(err);
			setMessageChargement(null);
			fonctionReponse(false);
		});
}

function telechargerFichier(lienTelechargement) {
	document.body.appendChild(lienTelechargement);
	lienTelechargement.click();
	window.URL.revokeObjectURL(lienTelechargement.href);
	lienTelechargement.remove();
}

function gererErreurApi(erreur) {
	afficherErreur(erreur.message);
	if (erreur.estFatale) {
		setTimeout(() => {
			window.location.reload();
		}, 5000);
	}
}

function afficherSucces(message) {
	toast.add({
		severity: 'success',
		summary: 'Succès', 
		detail: message,
		life: 2000
	});
}

function afficherInfo(message) {
	toast.add({
		severity: 'info',
		summary: 'Information', 
		detail: message,
		life: 2000
	});
}

function afficherErreur(messageErreur) {
  messageChargement.value = null;
	toast.add({
		severity: 'error',
		summary: 'Erreur', 
		detail: messageErreur,
		life: 5000
	});
}

function modifierLibellePage(libelle) {
  libellePage.value = libelle;
  document.title = libelle;
}

function setMessageChargement(message) {
  messageChargement.value = message;
}

function modifierUtilisateur(utilisateurModifie) {
    console.log('Enregistrement de l\'utilisateur');
  	apiModifierUtilisateur(utilisateurModifie).then(
	  	reponse => {
        Object.assign(utilisateur.value, reponse);
        utilisateur.value.estModifie = true;
      }, 
      err => {
        gererErreurApi(err);
      }
    );
}

provide('utilisateur', utilisateur);
provide('setMessageChargement', setMessageChargement);
provide('gererErreurApi', gererErreurApi);
provide('afficherSucces', afficherSucces);
provide('afficherInfo', afficherInfo);
provide('afficherErreur', afficherErreur);
provide('afficherBarreFlottante', afficherBarreFlottante);
provide('modifierLibellePage', modifierLibellePage);
provide('modifierUtilisateur', modifierUtilisateur);
provide('appelerApiTelechargement', appelerApiTelechargement);

</script>

<template>
	<Toast position="bottom-right" />
  <MessageChargement :message="messageChargement"/>
  <header>
    <Bandeau 
      :utilisateur="utilisateur" 
      :libelle-page="libellePage" />
  </header>
  <main>
    <router-view />
  </main>
  <Transition name="transition-barre-flottante">
    <BarreFlottante v-if="menuBarreFlottante" 
      :key="JSON.stringify(menuBarreFlottante.items)"
      :menu="menuBarreFlottante"
      @masquer="afficherBarreFlottante(null)" />
  </Transition>
</template>

<style scoped>

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    border-bottom: solid 1px lightgrey;
    padding: 10px;
  }

}

.transition-barre-flottante-enter-active,
.transition-barre-flottante-leave-active {
	transition: opacity 0.25s ease;
}

.transition-barre-flottante-enter-from,
.transition-barre-flottante-leave-to {
  opacity: 0;
}

</style>

<style>
@import "./assets/fontawesome/css/fontawesome.css";
@import "./assets/fontawesome/css/solid.css";
</style>
